import { enqueueActions } from 'xstate';

import { getAddTimeoutId, removeSelectionId } from '../../helpers';
import { type BundleMachineAction, type SelectionParams } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Records a product that failed to add, crashed or missed its deadline.
 */
export const settleFailedProduct: BundleMachineAction<SelectionParams> = enqueueActions(
  (args, params: SelectionParams) => {
    const { context, enqueue } = args;
    const { selectionId } = params;
    const { productAdds } = context;

    enqueue.cancel(getAddTimeoutId(selectionId));
    enqueue.assign({
      productAdds: {
        ...productAdds,
        inFlight: removeSelectionId({ selectionIds: productAdds.inFlight, selectionId }),
        failed: [...productAdds.failed, selectionId],
      },
    });
  },
);
